import { handleActions } from "redux-actions";
import extractApiError from "@utils/extract-api-error";
import { getReportsAPI, getReportSettingsAPI, updateReportSettingsAPI } from "@modules/apis/reports";
import { merge } from "lodash";

const initialState = {
    list: {
        data: null,
        pending: false,
        error: null,
    },
    settings: {
        data: null,
        pending: false,
        error: null,
    },
};

const GET_REPORT_SETTINGS_PENDING = "GET_REPORT_SETTINGS_PENDING";
const GET_REPORT_SETTINGS_SUCCESS = "GET_REPORT_SETTINGS_SUCCESS";
const GET_REPORT_SETTINGS_FAILURE = "GET_REPORT_SETTINGS_FAILURE";
const RESET_REPORT_SETTINGS = "RESET_REPORT_SETTINGS";
const GET_REPORTS_PENDING = "GET_REPORTS_PENDING";
const GET_REPORTS_SUCCESS = "GET_REPORTS_SUCCESS";
const GET_REPORTS_FAILURE = "GET_REPORTS_FAILURE";
const RESET_REPORTS = "RESET_REPORTS";
const UPDATE_REPORTS_SUCCESS = "UPDATE_REPORTS_SUCCESS";

export default handleActions(
    {
        [GET_REPORT_SETTINGS_PENDING]: (state) => {
            return { ...state, settings: { ...initialState.settings, pending: true, data: null, error: null } };
        },
        [GET_REPORT_SETTINGS_SUCCESS]: (state, action) => {
            return { ...state, settings: { ...state.settings, data: action.payload, pending: false } };
        },
        [GET_REPORT_SETTINGS_FAILURE]: (state, action) => {
            return {
                ...state,
                settings: { ...state.settings, pending: false, error: extractApiError(action.payload) },
            };
        },
        [RESET_REPORT_SETTINGS]: (state) => {
            return { ...state, settings: { ...initialState.settings } };
        },
        [GET_REPORTS_PENDING]: (state) => {
            return { ...state, list: { ...initialState.list, pending: true, data: null, error: null } };
        },
        [GET_REPORTS_SUCCESS]: (state, action) => {
            return { ...state, list: { ...state.list, data: action.payload, pending: false } };
        },
        [GET_REPORTS_FAILURE]: (state, action) => {
            return { ...state, list: { ...state.list, pending: false, error: extractApiError(action.payload) } };
        },
        [RESET_REPORTS]: (state) => {
            return { ...state, list: { ...initialState.list } };
        },
        [UPDATE_REPORTS_SUCCESS]: (state, action) => {
            return {
                ...state,
                settings: {
                    ...state.settings,
                    data: state.settings.data.map((setting) => {
                        if (setting.id === action.payload?.reportId) {
                            return merge(setting, action.payload?.data); //Note: action.payload.data의 구조가 가변적이기 때문에 deep merge를 사용
                        }
                        return setting;
                    }),
                },
            };
        },
    },
    initialState,
);

export const getReportSettings =
    ({ projectId, params }) =>
    async (dispatch, getState) => {
        const { stage } = getState();

        try {
            dispatch({ type: GET_REPORT_SETTINGS_PENDING });

            const response = await getReportSettingsAPI(stage.id, stage.endpoint, params);

            dispatch({
                type: GET_REPORT_SETTINGS_SUCCESS,
                payload: response.data.results,
            });

            return response.data?.nextToken;
        } catch (error) {
            dispatch({ type: GET_REPORT_SETTINGS_FAILURE, payload: error });
            throw error;
        }
    };

export const getReports =
    ({ projectId, params }) =>
    async (dispatch, getState) => {
        const { stage } = getState();

        try {
            dispatch({ type: GET_REPORTS_PENDING });

            const response = await getReportsAPI(stage.id, stage.endpoint, projectId, params);

            dispatch({
                type: GET_REPORTS_SUCCESS,
                payload: response.data.results,
            });

            return response.data?.nextToken;
        } catch (error) {
            dispatch({ type: GET_REPORTS_FAILURE, payload: error });
            throw error;
        }
    };

export const updateReportSettings =
    ({ projectId, reportId, data }) =>
    async (dispatch, getState) => {
        const { stage } = getState();

        try {
            const response = await updateReportSettingsAPI(stage.id, stage.endpoint, projectId, reportId, data);

            dispatch({
                type: UPDATE_REPORTS_SUCCESS,
                payload: { reportId, data },
            });
        } catch (error) {
            throw error;
        }
    };
